// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__p-DQ3","buttons":"Footer_buttons__2YyCY"};